import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ChargerService {
  apiUrl2 = `${environment.API_URL2}/Chargers` ;
  apiUrl3 = `${environment.API_URL3}/charger` ;
  apiUrl4 = `${environment.API_URL3}` ;
  public  chargerDetail:any;
  public chargerBookingobj:any;
  public chargerRowDetail:any;
  constructor(private http : HttpClient) { }

  create(params){
    return this.http.post(`${this.apiUrl2}/crt/`,params);
  }
  update(params){
    
    return this.http.post(`${this.apiUrl2}/upd/`,params);
  }
  addChargerToStation(params){
    
    return this.http.post(`${this.apiUrl2}/addChargerToStation/`,params);
  }

  removeChargerFromStation(params){
    return this.http.post(`${this.apiUrl2}/removeChargerFromStation/`,params);
  }

  getChargers(){
    return this.http.get(`${this.apiUrl2}/getChargers`);
  }
  getPlantChargers(){
    return this.http.get(`${this.apiUrl2}/gtPlantChargers`);
  }
  getClientChargers(){
    return this.http.get(`${this.apiUrl2}/getClientChargers`);
  }

  //might not be in use as it is getting data from outdated field station_id in charger_serial_mst
  // but a new mapping table was created for charger and station mapping , so data must be come from
  //that mapping table
  // getChargersByStationId(id){
  //   return this.http.get(`${this.apiUrl2}/getChargersByStationId/${id}`);
  // }

  getChargersByMappedStationId(id){
    return this.http.get(`${this.apiUrl2}/getChargersByMappedStationId/${id}`);
  }

  getChargerBySerialNo(params){
    return this.http.get(`${this.apiUrl2}/getChargerBySerialNo/${params.srNo}`);
  }

  getChargerById(id){
    return this.http.get(`${this.apiUrl2}/gtChargerById/${id}`);
  }

  getChargerByDisplayId(display_id){
    return this.http.get(`${this.apiUrl2}/gtChargerByDisplayId/${display_id}`);
  }
  
  delete(id){
    return this.http.delete(`${this.apiUrl2}/dlt/${id}`);
  }

  deleteChargerFromClient(id,user_id){
    return this.http.delete(`${this.apiUrl2}/deleteChargerFromClient/${id}/${user_id}`);
  }

  getChargerLogs(login_id,params){
    return this.http.post(`${this.apiUrl3}/${login_id}`,params);
  }
  getCharger(params){
    return this.http.post(`${this.apiUrl3}`,params);
  }
  getActiveTransactionId(params){
    return this.http.get(`${this.apiUrl4}/getActiveTransactionId/${params.charger_id}/${params.connector}`);
  }
  getProductDispatch(params){
    return this.http.post(`${this.apiUrl2}/dispatchChargers`,params);
  }
  getAllClientChargers(params){
    return this.http.get(`${this.apiUrl2}/getClientChargers/${params}`);
  }
   getUpdateClientCharger(params){
    return this.http.post(`${this.apiUrl2}/updateClientChargers`,params);
  }
  getDynamicChargers(params){
    return this.http.post(`${this.apiUrl2}/getChargersDynamicFilter`,params);
  }
  getDynamicChargersCW(login_id,params){
    return this.http.post(`${this.apiUrl2}/getChargersDynamicFilterCW/${login_id}`,params);
  }
  getClientChargersNotMappedToAnyStation(id){
    return this.http.get(`${this.apiUrl2}/gtClientChargersNotMappedToAnyStation/${id}`);
  }
  addChargerToStationMultiple(params){
    return this.http.post(`${this.apiUrl2}/addChargerToStationMultiple`,params);
  }
  getActiveChargersByMappedStationId(id){
    return this.http.get(`${this.apiUrl2}/gtActiveChargersByMappedStationId/${id}`);
  }
  getChargersDynamicFilterCW(id,params){
    return this.http.post(`${this.apiUrl2}/getChargersDynamicFilterCW/${id}`,params);
  }
  updateNickName(params){
    return this.http.post(`${this.apiUrl2}/updateNickName`,params);
  } 

  // Comment for 
  // getChargersDynamicFilterCCS(login_id,client_id,cpo_id,station_id){
  //   return this.http.get(`${this.apiUrl2}/getChargersDynamicFilterCCS/${login_id}/${client_id}/${cpo_id}/${station_id}`);
  // }

  // New Url for just get dummy data
  getChargersDynamicFilterCCS(login_id,client_id,cpo_id,station_id){
    return this.http.get(`${this.apiUrl2}/getChargersDynamicFilterCWise/${login_id}/${cpo_id}/${station_id}/${client_id}`);
  }
}
